import axios from 'axios'
import { CADASTRAR_CONFIGURACAO_ENCOMENDA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarConfiguracaoEncomenda(empresaId, configuracao) {
  const url = `${URL}/empresas/${empresaId}/cadastrar-configuracao-encomenda`;
  return dispatch => axios.post(url, configuracao, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: CADASTRAR_CONFIGURACAO_ENCOMENDA,
      payload: response
    })
  );
}